import { GetMyVesselsQueryVariables } from 'src/gql';

export const LIMIT = 10;

export const MY_VESSELS_VARIABLES: GetMyVesselsQueryVariables = { limit: 100, offset: 0 };
